/* @flow */
import BoxHeader from 'components/BoxHeader';
import Buttons from 'components/Buttons';
import Group from 'entities/Group';
import * as React from 'react';
import Relationship from 'entities/Relationship';
import StartChatButton from 'user/components/StartChatButton';
import StatusLabel from 'components/StatusLabel';
import Subscriber from 'entities/Subscriber';
import Text from 'components/Text';
import UserActionsMenuButton from 'user/components/UserActionsMenuButton';
import PhoneCallButton from 'phoneCalls/components/PhoneCallButton';
import { isFixableDenialReason } from 'phoneCalls/components/PhoneCallModal';
import { withPhoneCallPermissions } from 'phoneCalls/lib/permissions';

import type { UserActionsMenuButtonUser } from 'user/components/UserActionsMenuButton';

// User props this component needs directly
export type NewUserProps = {
  is_owner: boolean,
  can_become_owner: boolean,
  can_admin: boolean,
  can_remove_from_group: boolean,
  can_remove_from_org: boolean,
};

export type User = NewUserProps & UserActionsMenuButtonUser;

type Props = {
  relationship: Relationship,
  subscriber: Subscriber,
  groupToAdmin?: Group,
  onRequestHide: Function,
  canMakePhoneCalls: boolean,

  user?: User,
};

export class RelationshipViewHeader extends React.Component<Props> {
  renderHeaderAux = () => {
    const { relationship, user, groupToAdmin, subscriber, canMakePhoneCalls } = this.props;
    const canPhone =
      (subscriber.getCanPhone() || isFixableDenialReason(subscriber.getCanPhoneDenialReason())) &&
      canMakePhoneCalls;

    const userOrObj = user || {};
    const hasGroup = groupToAdmin && !groupToAdmin.isRoot();

    const menuButtonOptionsFromSubscriber = makeMenuButtonOptionsFromSubscriber(subscriber);

    return (
      <Buttons>
        {relationship.isEligibleForChat() && (
          <StartChatButton subscriber={subscriber} onRequestHide={this.props.onRequestHide} />
        )}
        {canPhone && (
          <PhoneCallButton
            calleeName={subscriber.getName()}
            calleeUuid={subscriber.getUuid()}
            size="xsmall"
          />
        )}
        <UserActionsMenuButton
          glyphSize="small"
          user={user || menuButtonOptionsFromSubscriber}
          groupToAdmin={groupToAdmin}
          showChangeRole={false}
          showCopyToClass={subscriber.getCanBeCopiedToClass()}
          showMakeOwner={hasGroup && userOrObj.can_become_owner}
          showRemoveMember={hasGroup && userOrObj.can_remove_from_group}
          showBlockMember={!!user}
          showGetTranscript={userOrObj.can_admin}
          showRemoveFromSchool={userOrObj.can_remove_from_org}
          showReportAsUser={!hasGroup || !userOrObj.can_admin}
          showReportAsAdmin={hasGroup && userOrObj.can_admin}
        />
      </Buttons>
    );
  };

  render() {
    const { relationship, subscriber } = this.props;

    let name = <Text truncate>{subscriber.getName()}</Text>;

    let status;
    if (relationship.isPendingForChat()) {
      status = 'Pending';
    } else if (relationship.isUnder13()) {
      status = 'Under 13';
    }

    if (status) {
      name = (
        <div>
          {name}
          <StatusLabel>{status}</StatusLabel>
        </div>
      );
    }

    return (
      <BoxHeader title={name} action={this.renderHeaderAux()} className="RelationshipViewHeader" />
    );
  }
}

function makeMenuButtonOptionsFromSubscriber(subscriber: Subscriber) {
  return {
    id: subscriber.id,
    uuid: subscriber.getUuid(),
    name: subscriber.getName(),

    first_name: subscriber.getFirstName(),
    last_name: subscriber.getLastName(),
    blocked: subscriber.isBlocked(),

    is_owner: false,
    can_become_owner: false,
    can_admin: false,
    can_remove_from_group: false,
    can_remove_from_org: false,

    can_have_role_changed: false,
    roles: [],
    potential_roles: [],

    can_get_message_history: false,
    can_request_message_history: false,
  };
}

export default withPhoneCallPermissions(RelationshipViewHeader);
